module.exports = {versao:  913 ,
old:true,
parceria:false,
url:"https://sec-stag-api.aplicativogo.com.br/"};
